import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { login as apiLogin, getProfile, logout as apiLogout } from '../services/api';

// Runs once on app load (replaces the old checkAuth() inside AuthContext's useEffect)
export const checkAuthStatus = createAsyncThunk(
    'auth/checkStatus',
    async (_, { rejectWithValue }) => {
        const token = localStorage.getItem('token');
        if (!token) {
            return rejectWithValue(null);
        }
        try {
            const userData = await getProfile();
            return userData;
        } catch (error) {
            localStorage.removeItem('token');
            return rejectWithValue(error);
        }
    }
);

// Same success/error shape the old AuthContext.login() produced
export const loginUser = createAsyncThunk(
    'auth/login',
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await apiLogin(credentials);
            // Preserve the original "200 status but status:false payload" guard
            if (response.status === false) {
                return rejectWithValue(response);
            }
            localStorage.setItem('token', response.token);
            return response.UserData;
        } catch (error) {
            return rejectWithValue({
                message: error.message || 'Login failed',
                httpStatus: error.httpStatus || 500,
            });
        }
    }
);

export const logoutUser = createAsyncThunk(
    'auth/logout',
    async () => {
        await apiLogout();
        localStorage.removeItem('token');
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        isAuthenticated: false,
        loading: true,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(checkAuthStatus.pending, (state) => {
                state.loading = true;
            })
            .addCase(checkAuthStatus.fulfilled, (state, action) => {
                state.user = action.payload;
                state.isAuthenticated = true;
                state.loading = false;
            })
            .addCase(checkAuthStatus.rejected, (state) => {
                state.user = null;
                state.isAuthenticated = false;
                state.loading = false;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.user = action.payload;
                state.isAuthenticated = true;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                state.user = null;
                state.isAuthenticated = false;
            });
    },
});

export default authSlice.reducer;